<template>
    <div class="news-header">
        <div class="news-main flex-align-around">
            <ul class="nav-right flex-align">
                <li class="nav-list" v-for="(nav, index) in navs" :class="$store.state.isActive == index ? 'active' : ''"
                    @click="selected(index, nav)">
                    <router-link to='' @click.native="showToggle(index)">{{ nav.name }}</router-link>
                    <ul class="dropdownWrapper" :class="{ 'active': index === isShow }">
                        <li v-for='(item, indexs) in nav.dropParams' :class="isActiveB === indexs ? 'disable' : ''"
                            @click="menuselected(indexs)">
                            <router-link class="menu_ul_text" :to="item.href"
                                :class="{ 'disable': item.href === linkClick }" @click.native="treeNavSwitch(item)">{{
                                    item.name }}</router-link>
                        </li>
                    </ul>

                </li>

            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        page: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            // isActive:0, 
            isShow: 0,
            isActiveB: 0,
            linkClick: '',
            navs: [{
                name: '首页',
                href: '/home',
            }, {
                name: '通知公告',
                href: '/list/course',
            }, {
                name: '考试指导',
                href: '/list/examGuidance',
            }, {
                name: '组考单位',
                href: '/list/information',
            }, {
                name: '特色服务',
                href: '',
                dropParams: [{
                    name: '书画教师能力提升服务',
                    href: '/list/improve'
                }, {
                    name: '书画培训机构增值服务',
                    href: '/list/added'

                }],
            }, {
                name: '巡展活动',
                href: '/list/exhibition',
                // title:'敬请期待'

            }, {
                name: '关于我们',
                href: '/aboutus'
            }
            ]
        }
    },

    methods: {
        selected(index, nav) {
            // this.isActive = index;
            this.$store.commit('addcount', index)
            sessionStorage.setItem('isActive', index)
            //  if (nav.title) {
            //     this.$message({
            //     message: nav.title,
            //     type: 'success'
            //   });
            // }
            this.$nextTick(function () {
                this.$router.push(nav.href)
            })
        },
        showToggle(index) {
            this.isShow = index;

        },
        menuselected(nav) {
            //  this.$nextTick(function(){
            this.isActiveB = nav;

            // })

        },
        treeNavSwitch(nav) {
            this.linkClick = nav.href;

        }
    },
    mounted() {
      
        if (sessionStorage.getItem('isActive') != null) {
            this.$store.commit('addcount', sessionStorage.getItem('isActive'))
        }
    },
}
</script>

<style lang="less" scoped>
.news-header {
    font-size: 16px;
    background-color: #900000;
}

.news-main {
    box-sizing: border-box;
    margin: 0 auto;
    width: 1200px;
}

.nav-right {
    .nav-list {
        // padding: 0 65px;
        padding: 0 50px;
        line-height: 50px;
        color: #fff;
        position: relative;
        cursor: pointer;
        &:hover {
            color: #fff;
            background-color: #d0a85c;
        }
    }

    .active {
        color: #fff;
        background-color: #d0a85c;
    }

    .nav-list:hover .dropdownWrapper {
        display: block;
    }

    .dropdownWrapper {
        position: absolute;
        z-index: 9999;
        top: 50px;
        left: 3px;
        background-color: #333434;
        color: #fff;
        border-top: none;
        font-size: 15px;
        display: none;

        li {
            padding: 0 20px;
        }
    }

    .menu_ul_text:hover {
        color: #d0a85c;
    }

    .dropdownWrapper li.disable .menu_ul_text {
        color: #d0a85c;
    }
}

a {
    display: block;
    color: #fff;
}
</style>